import { EditIcon, ArrowNavRightIcon } from "@bookingcom/bui-assets-react/streamline";
import { Stack, Icon, Text, Link } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { getUpdatedSearchParams } from "../../../../hooks/useSearchFilters.js";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getFiltersDraftOutbound } from "../../../../store/search/selectors.js";
import flights_split_bounds_us from "../../../../utils/experiments/funnel/flights_split_bounds_us.js";
import { clearSplitBoundsBrandedFareParams } from "../../../../utils/splitBoundsBrandedFareParams.js";
const BackToOutbound = () => {
    const i18n = useI18n();
    const params = useParams();
    const history = useHistory();
    const outboundFilters = useSelector(getFiltersDraftOutbound);
    const outboundParams = getUpdatedSearchParams(outboundFilters);
    clearSplitBoundsBrandedFareParams(outboundParams);
    const url = `/flights/${params?.airports}/outbound/?${outboundParams.toString()}`;
    const onLinkClick = (e) => {
        e.preventDefault();
        flights_split_bounds_us.goals.change_departing_cta();
        history.push(url);
    };
    return (React.createElement(Stack, { direction: "row", alignItems: "center" },
        React.createElement(Text, { variant: "strong_2", tagName: "h2" },
            React.createElement(Link, { text: i18n.trans(t("flights_sr_split_bounds_us_change_departing")), icon: EditIcon, iconPosition: "start", href: url, onClick: onLinkClick })),
        React.createElement(Icon, { svg: ArrowNavRightIcon, size: "medium" }),
        React.createElement(Text, { variant: "strong_2", tagName: "h2" }, i18n.trans(t("flights_sr_split_bounds_us_select_returning")))));
};
export default BackToOutbound;
